import attributeChanged from "standard/attributeChanged";
import define from "standard/define";
import joinCut from "standard/joinCut";
import paint from "standard/paint";
import trait from "standard/trait";
import style from "./style";
import ToReview from "./toReview";

@define("m-study")
class Study extends HTMLElement {
  #deck;
  #validity;

  get [trait.deck]() {
    return (this.#deck ??= "");
  }

  get [trait.validity]() {
    return (this.#validity ??= new Date().getTime());
  }

  static get observedAttributes() {
    return ["deck"];
  }

  constructor() {
    super();
    this.attachShadow({ mode: "open" });
  }

  @attributeChanged("deck")
  @joinCut(trait.template)
  [trait.changeDeck](value) {
    this.#deck = value;
    return this;
  }

  @paint
  async [trait.template]() {
    return (await ToReview.create(this)).template();
  }
}

export default Study;
